<template>
  <VCardImportFormSection title="User Info">
    <v-row>
      <v-col cols="4">
        First Name
      </v-col>
      <v-col cols="8">
        <VCardImportSelect
          v-model="parsedData.first_name"
          :items="items"
        />
      </v-col>
      <v-col cols="4">
        Last Name
      </v-col>
      <v-col cols="8">
        <VCardImportSelect
          v-model="parsedData.last_name"
          :items="items"
        />
      </v-col>
      <v-col cols="4">
        Email
      </v-col>
      <v-col cols="8">
        <VCardImportSelect
          v-model="parsedData.email"
          :items="items"
        />
      </v-col>
      <v-col cols="4">
        Title
      </v-col>
      <v-col cols="8">
        <VCardImportSelect
          v-model="parsedData.title"
          :items="items"
        />
      </v-col>
    </v-row>
  </VCardImportFormSection>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { VCardSectionMixin } from '@/bundles/Contact/mixins/VCardSectionMixin';

export default defineComponent({
  name: 'VCardImportUserInfo',
  mixins: [VCardSectionMixin],
});
</script>
